import React,{useState, useEffect} from 'react';
import { Table, DatePicker, Button, Space } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import moment from 'moment'

import SelfTable from "../../../../components/SelfTable/index"

import './index.scss'
import Api from "../../../../api";
import {pagingParam} from "../../../../utils/defaultValue";
import {downloadFileBlob, get7DaysDate} from "../../../../utils/tool";

const { RangePicker } = DatePicker;

const ContributeStatistics = () => {

    const defalRange = get7DaysDate();

    // 分页
    const [pagination, setPagination] = useState({
        "pageIndex": 0,
        "pageSize": 0,
        "total":0
    });
    const [sortedInfo, setSortedInfo] = useState({});
    // 查询数据
    const [searchData, setSearchData] = useState({
        ...pagingParam,
        ...defalRange
    });

    const [tableLoading, setTableLoading] = useState(false);

    const [listData, setListData] = useState([]);

    const [department, setDepartment] = useState([]);

    const [operationData, setOperationData] = useState(defalRange);
    
    const columns = [
        {
            title: '部门名称',
            dataIndex: 'departmentId',
            width: '',
            filters: [...department.filter((val, i) => {
                return val.value !== ''
            })],
            filterMultiple:false,
            filteredValue:searchData.departmentId ? [searchData.departmentId] : [],
            render:(_, record)=>{
                return record.departmentName
            },
        },
        {
            title: '上传数量（篇）',
            dataIndex: 'uploadNum',
            width: '150px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'uploadNum' ? sortedInfo.order : null,
        },
        {
            title: '被阅读量(次）',
            dataIndex: 'readNum',
            width: '150px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'readNum' ? sortedInfo.order : null,
        },
        {
            title: '被下载量（次）',
            dataIndex: 'downloadNum',
            width: '150px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'downloadNum' ? sortedInfo.order : null,
        },
        {
            title: '被收藏量（次）',
            dataIndex: 'collectionNum',
            width: '150px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'collectionNum' ? sortedInfo.order : null,
        },
        {
            title: '收获点赞量(次）',
            dataIndex: 'likeNum',
            width: '160px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'likeNum' ? sortedInfo.order : null,
        },
        {
            title: '收获评论量（条）',
            dataIndex: 'commentNum',
            width: '160px',
            sorter: true,
            sortOrder: sortedInfo.columnKey === 'commentNum' ? sortedInfo.order : null,
        }
    ];

    useEffect(()=>{
        getList()
    },[JSON.stringify(searchData)])

    useEffect(()=>{
        setInitDate();
    },[])

    const setInitDate = async() => {
        const resDepartment = await Api.Department.getDepartmentListAll({});
        if(resDepartment && resDepartment.code === 0){
            let newData = resDepartment.data.map(item=>{
                return{
                    value: item.id,
                    label: item.name,
                    text: item.name,
                }
            });
            newData.push({
                value: '',
                label: '无',
            })
            setDepartment(newData);
        }
    }

    const getList = async() => {
        setTableLoading(true);
        const res = await Api.Statistics.getContributeStatisticsList({data:searchData});
        setTableLoading(false);
        if(res&&res.code === 0){
            let _data = res.data;
            setListData(_data.records);
            setPagination({
                "pageIndex": _data.current,
                "pageSize": _data.size,
                "total":_data.total
            });
        }else{
            setListData([]);
        }
    }

    const onChanges = (pagination, filters, sorter, extra) => {
        let newSearchData = {...searchData}
        newSearchData.typeSortMessage = sorter.field === 'uploadNum' ? 0:
        sorter.field === 'readNum' ? 1:
        sorter.field === 'downloadNum' ? 2:
        sorter.field === 'collectionNum' ? 3:
        sorter.field === 'likeNum' ? 4:
        sorter.field === 'commentNum' ? 5:'';
        newSearchData.sort = sorter.order === 'descend' ? 0 : sorter.order === 'ascend' ? 1 :'';
        setSortedInfo({
            order: sorter.order,
            columnKey: sorter.field,
        });
        newSearchData.pageIndex = pagination.current;
        newSearchData.pageSize = pagination.pageSize;
        for (let key in filters) {
            newSearchData[key] = filters[key] ? filters[key][0] : ''
        }
        setSearchData(newSearchData);
    };

    const dateChange = (date, dateString) => {
        let newSearchData = {...searchData}
        newSearchData.startTime = dateString[0];
        newSearchData.endTime = dateString[1];
        newSearchData.pageIndex = 1;
        setSearchData(newSearchData);
    }

    const exportFile = async() => {
        try{
            const res = await Api.Statistics.getContributeStatisticsExport({data:searchData});
            if(res){
                downloadFileBlob(res,'部门知识贡献统计明细.xlsx')
            }
        }catch{

        }
    }

    const searchChange = (value, type) => {
        let newOperationData = {...operationData};
        newOperationData.startTime = value[0];
        newOperationData.endTime = value[1];
        newOperationData.pageIndex = 1;
        setOperationData(newOperationData)
    }

    const onSearch = () => {
        setSearchData({
            ...searchData,
            ...operationData
        });
    }

    const onResetting = () => {
        setOperationData(defalRange);
        setSearchData({
            ...pagingParam,
            ...defalRange
        })
        setSortedInfo({});
    }

    const disabledDate = (current) => {
        // Can not select days after today and today
        return current && current > moment().endOf('day');
    };

    return(
        <div className="contributeStatisticsFrame">
            <div className="title">部门知识贡献统计</div>
            <div className="operation">
                <Space size={"large"}>
                    <div className="operationItem">
                        选择时段：
                        <RangePicker 
                        ranges={{
                            '当天': [moment(), moment()],
                            '近7天':[moment().subtract(7, 'day'), moment()],
                            '本月': [moment().startOf('month'), moment()],
                            '近三个月': [moment().subtract(3, 'months'), moment()],
                        }}
                        disabledDate={disabledDate}
                        value={operationData.startTime?[moment(operationData.startTime), moment(operationData.endTime)]:[]}
                        onChange={(date, dateString)=>{
                            searchChange(dateString,"timeRange")
                        }}/>
                    </div>
                    <Button type="primary" onClick={onSearch}>搜索</Button>
                    <Button onClick={onResetting}>重置</Button>
                </Space>

                <div className="operationRight">
                    <Space size={"large"}>
                        <Button onClick={exportFile} icon={<DownloadOutlined />}>导出</Button>
                    </Space>
                </div>
            </div>
            <div className="table">
                <SelfTable
                    dataSource={listData}
                    columns={columns}
                    pagination={pagination}
                    loading={tableLoading}
                    onChange={onChanges} 
                />
                {/* <Table 
                    rowKey="id" 
                    columns={columns} 
                    bordered 
                    dataSource={listData} 
                    onChange={onChanges} 
                    pagination={{
                        total:pagination.total,
                        current:pagination.pageIndex,
                        pageSize:pagination.pageSize,
                        showSizeChanger:true,
                        showQuickJumper:true,
                        showTotal:()=> `总计${pagination.total}条数据`
                    }}
                    scroll={{
                        scrollToFirstRowOnChange:true,
                        y:tableHight
                    }}
                    loading={tableLoading}
                /> */}
            </div>
        </div>
    )
}
export default ContributeStatistics